
import { Component, Vue, Watch } from 'vue-property-decorator';
import EditReservation from '@/components/view/EditReservation.vue';
import StepCalendar from '@/components/reservation/StepCalendar.vue';
import StepTime from "@/components/reservation/StepTime.vue";
import StepData from "@/components/reservation/StepData.vue";
import StepConfirmation from "@/components/reservation/StepConfirmation.vue"; // @ is an alias to /src

import { AxiosStatic } from 'axios';
import IResource from "@/IResource";
import IReservation from '@/IReservation';
import OrganisationMain from "@/components/organisation/OrganisationMain.vue";
import IOrganisation from "@/IOrganisation";
import ReservationFooter from "@/components/reservation/ReservationFooter.vue";

@Component({
	components: {
		EditReservation,
		StepCalendar,
		StepTime,
		StepData,
		StepConfirmation,
		OrganisationMain,
		ReservationFooter
	},
})
export default class App extends Vue {

	public $http!: AxiosStatic;

	public showLoadingError: boolean = false;

	get mode() {
		return this.$store.state.mode;
	}

	get step() {
		return this.$store.state.step;
	}

	get resource(): IResource {
		return this.$store.state.resource;
	}

	get reservation(): IReservation {
		return this.$store.state.reservation;
	}

	get organisation(): IOrganisation {
		return this.$store.state.organisation;
	}

	get theme_color(): string | null {
		if (this.organisation && this.organisation.theme_color) {
			return this.organisation.theme_color;
		}
		if (this.resource && this.resource.theme_color) {
			return this.resource.theme_color;
		}
		return null;
	}

	get color_booked(): string | null {
		if (this.organisation && this.organisation.color_booked) {
			return this.organisation.color_booked;
		}
		if (this.resource && this.resource.color_booked) {
			return this.resource.color_booked;
		}
		return null;
	}

	get color_new(): string | null {
		if (this.organisation && this.organisation.color_new) {
			return this.organisation.color_new;
		}
		if (this.resource && this.resource.color_new) {
			return this.resource.color_new;
		}
		return null;
	}

	get color_locked(): string | null {
		if (this.organisation && this.organisation.color_locked) {
			return this.organisation.color_locked;
		}
		if (this.resource && this.resource.color_locked) {
			return this.resource.color_locked;
		}
		return null;
	}

	get color_free(): string | null {
		if (this.organisation && this.organisation.color_free) {
			return this.organisation.color_free;
		}
		if (this.resource && this.resource.color_free) {
			return this.resource.color_free;
		}
		return null;
	}

	get helperClasses() {
		let classes = {};
		if (this.resource) {
			Vue.set(classes, 'rk-resource-' + this.resource.id, true);
		}
		if (this.mode) {
			Vue.set(classes, 'rk-page-' + this.mode, true);
		}
		return classes;
	}

	public async mounted() {
		this.parseHashFromUrl();
		if (this.$store.state.resourcehash) {
			this.loadResource();
		}
		if (this.$store.state.customeredithash) {
			this.loadReservation();
		}
		if (this.$store.state.organisationhash) {
			this.loadOrganisation();
		}
	}

	public parseHashFromUrl() {
		let resourceHash: string = '';
		let organisationHash: string = '';
		let customerEditHash: string = '';
		let parts = window.location.pathname.split('/');
		if (parts.length > 3 && parts[parts.length - 4] == 'reservation' && parts[parts.length - 2] == 'view') {
			resourceHash = parts[parts.length - 3];
			customerEditHash = parts[parts.length - 1];
			this.$store.commit('SET_MODE', 'view')
			this.$store.commit('SET_STEP', 'view')
		} else if (parts.length > 2 && parts[parts.length - 3] == 'reservation') {
			//with name
			resourceHash = parts[parts.length - 2];
			this.$store.commit('SET_MODE', 'resource')
		} else if (parts.length > 2 && parts[parts.length - 3] == 'org') {
			//with name
			organisationHash = parts[parts.length - 2];
			this.$store.commit('SET_MODE', 'organisation')
		} else if (parts.length > 1 && parts[parts.length - 2] == 'reservation') {
			//without name
			resourceHash = parts[parts.length - 1];
			this.$store.commit('SET_MODE', 'resource')
		} else if (parts.length > 1 && parts[parts.length - 2] == 'org') {
			//without name
			organisationHash = parts[parts.length - 1];
			this.$store.commit('SET_MODE', 'organisation')
		}
		if (!resourceHash && !organisationHash) {
			// development fallback
			resourceHash = 'demoraum1reservationhash';
		}
		this.$store.commit('SET_RESOURCEHASH', resourceHash)
		this.$store.commit('SET_ORGANISATIONHASH', organisationHash)
		this.$store.commit('SET_CUSTOMEREDITHASH', customerEditHash)
	}

	public async loadOrganisation() {
		try {
			const response = await this.$http.get(`/public/organisation/${this.$store.state.organisationhash}`);
			this.$store.commit('SET_ORGANISATION', response.data);
			// inject css
			if (response.data.css) {
				let element = document.getElementById('custom_css');
				if (element) {
					element.innerHTML = response.data.css;
				}
			}
			//SEO
			if (this.mode == 'organisation' && this.organisation && this.organisation.name) {
				document.title = 'Reservation ' + this.organisation.name;
				if (this.organisation.multicalendar_description && document.querySelector('meta[name="description"]')) {
					document.querySelector('meta[name="description"]')?.setAttribute("content", this.organisation.multicalendar_description);
				}
			}
		} catch (e) {
			this.showLoadingError = true;
		}
	}

	public async loadResource() {
		try {
			const response = await this.$http.get(`/public/resource/${this.$store.state.resourcehash}`);
			this.$store.commit('SET_RESOURCE', response.data);
			let min_date = new Date();
			min_date.setHours(min_date.getHours() + response.data.min_hours_to_reservation);
			this.$store.commit('SET_MINRESERVATIONTIME', min_date);
			this.injectCss(response.data.css);
			//SEO
			if (this.mode == 'resource' && this.resource && this.resource.name) {
				document.title = 'Reservation ' + this.resource.name;
				if (this.resource.description && document.querySelector('meta[name="description"]')) {
					document.querySelector('meta[name="description"]')?.setAttribute("content", this.resource.description);
				}
			}
		} catch (e) {
			this.showLoadingError = true;
		}
	}

	public async loadReservation() {
		try {
			const response = await this.$http.get(`/public/resource/${this.$store.state.resourcehash}/reservation/${this.$store.state.customeredithash}`);
			this.$store.commit('SET_RESERVATION', response.data);
		} catch (e) {
			this.showLoadingError = true;
		}
	}

	public injectCss(css: string) {
		let element = document.getElementById('custom_css');
		if (element) {
			element.innerHTML = css;
		}
	}

	@Watch('theme_color')
	public setThemeColors() {
		if (this.theme_color && this.theme_color.length === 7 && this.theme_color[0] == "#") {
			let root = document.documentElement;
			root.style.setProperty('--theme-color', this.theme_color);
			root.style.setProperty('--theme-color-darker', this.lightenColor(this.theme_color, -15));
			root.style.setProperty('--theme-color-transparent', this.theme_color + '80');
		}
	}

	@Watch('color_booked')
	public setBookedColor() {
		if (this.color_booked && this.color_booked.length === 7 && this.color_booked[0] == "#") {
			let root = document.documentElement;
			root.style.setProperty('--singleday-calendar-bg-color--booked', this.color_booked);
			root.style.setProperty('--multiday-calendar-bg-color--booked', this.color_booked);
			root.style.setProperty('--multiday-calendar-border-color--booked', this.lightenColor(this.color_booked, -15));
		}
	}

	@Watch('color_new')
	public setNewColor() {
		if (this.color_new && this.color_new.length === 7 && this.color_new[0] == "#") {
			let root = document.documentElement;
			root.style.setProperty('--singleday-calendar-bg-color--new', this.color_new);
			root.style.setProperty('--multiday-calendar-bg-color--new', this.color_new);
			root.style.setProperty('--multiday-calendar-border-color--new', this.lightenColor(this.color_new, -15));
		}
	}

	@Watch('color_locked')
	public setLockedColor() {
		if (this.color_locked && this.color_locked.length === 7 && this.color_locked[0] == "#") {
			let root = document.documentElement;
			root.style.setProperty('--singleday-calendar-bg-color--locked', this.color_locked);
			root.style.setProperty('--multiday-calendar-bg-color--locked', this.color_locked);
			root.style.setProperty('--multiday-calendar-border-color--locked', this.lightenColor(this.color_locked, -15));
		}
	}

	@Watch('color_free')
	public setFreeColor() {
		if (this.color_free && this.color_free.length === 7 && this.color_free[0] == "#") {
			let root = document.documentElement;
			root.style.setProperty('--singleday-calendar-bg-color--free', this.color_free);
			root.style.setProperty('--multiday-calendar-bg-color--free', this.color_free);
			root.style.setProperty('--multiday-calendar-border-color--free', this.lightenColor(this.color_free, -13));
		}
	}

	public lightenColor(color: string, percent: number) {
		let num = parseInt(color.replace("#",""),16),
			amt = Math.round(2.55 * percent),
			R = (num >> 16) + amt,
			B = (num >> 8 & 0x00FF) + amt,
			G = (num & 0x0000FF) + amt;
		return '#' + (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (B<255?B<1?0:B:255)*0x100 + (G<255?G<1?0:G:255)).toString(16).slice(1);
	};
}
